module.exports = __webpack_public_path__ + "img/zhifubao-checked.aa2f7bfc.png";